import { ObstacleMapData } from "../ObstacleMapData";
import { MovingObsSettings } from "./MovingObsSettings";



export class MovingObsMapData extends ObstacleMapData {
    /**
     * (RO) Cilovy pozice prekazky na ose X, na ktere bude prekazka v moment, kdy hrac dosahne pozice Z prekazky.
     * Hodnota musi byt v rozsahu 0 az 1 a jedna se o pomer v rozsahu mozneho pohybu prekazky (0 = minimalni X prekazky, 1 = maximalni X prekazky).
     */
    get targetPosRatio(): number { return this._targetPos; }
    private _targetPos: number;

    /**
     * (RO) Smer, ze ktereho ma byt dosazena cilova pozice prekazkou (-1 = zprava, 1 = zleva)
     */
    get targetPosReachDir(): number { return this._targetPosReachDir; }
    private _targetPosReachDir: number;

    //-------------------------------------------------------------------------
    /**
     * 
     * @param targetPos Cilovy pozice prekazky na ose X, na ktere bude prekazka v moment, kdy hrac dosahne pozice Z prekazky. Hodnota musi byt v rozsahu 0 az 1 a jedna se o pomer v rozsahu mozneho pohybu prekazky (0 = minimalni X prekazky, 1 = maximalni X prekazky).
     * @param targetPosReachDir Smer, ze ktereho ma byt dosazena cilova pozice prekazkou (-1 = zprava, 1 = zleva)
     * @param settings 
     */
    //-------------------------------------------------------------------------
    constructor(targetPos: number, targetPosReachDir: number, settings: MovingObsSettings) {
        super(0, settings);

        this._targetPos = targetPos;
        this._targetPosReachDir = targetPosReachDir;
    }
}